import {
  Autocomplete,
  Divider,
  Paper,
  TextField,
  Typography,
  Button,
  CircularProgress,
  // FormControl,
  // FormControlLabel,
  // Radio,
  // RadioGroup,
} from "@mui/material";
import { useMutation } from "react-query";
import {
  getAllPrivilages,
  getUsers,
  // getUserTypes
} from "./services";
import {
  // ChangeEvent,
  createContext,
  SyntheticEvent,
  useEffect,
  useState,
} from "react";
import {
  UserPrivilageContextProvider,
  UsersListType,
  UsersTypeList,
} from "./types";
import PrivilagesEdit from "./PrivilagesEdit";

export const PrivilageSettingProvider =
  createContext<UserPrivilageContextProvider>({
    loading: false,
    privilages: { permissions: [] },
    selectedType: null,
    setSelectedType: () => {},
    triggerSave: false,
    setTriggerSave: () => {},
    resetPrivilages: () => {},
  });

const UserPrivilages = () => {
  const [selectedType, setSelectedType] = useState<
    (UsersListType & UsersTypeList) | null
  >(null);
  const [triggerSave, setTriggerSave] = useState<boolean>(false);
  const {
    mutate: fetchPrivilage,
    data: privilages,
    isLoading: privilagesLoading,
    reset: resetPrivilages,
  } = useMutation(getAllPrivilages);
  const {
    mutate: fetchUser,
    data: users,
    isLoading: userLoading,
    // reset: resetUsers,
  } = useMutation(getUsers);
  // const {
  //   mutate: fetchUserGroups,
  //   data: usersGroups,
  //   isLoading: usersGroupsLoading,
  //   reset: resetUserGroups,
  // } = useMutation(getUserTypes);

  // const handleSelectType = (e: ChangeEvent<HTMLInputElement>) => {
  //   if (Boolean(Number(e.target.value))) {
  //     resetUsers();
  //     fetchUserGroups();
  //   } else {
  //     resetUserGroups();
  //     fetchUser();
  //   }
  //   resetPrivilages();
  //   setSelectedType(null);
  // };

  const handleDropdownChange = (
    _: SyntheticEvent,
    value: (UsersListType & UsersTypeList) | null
  ) => {
    console.log(value);
    if (value) {
      setSelectedType(value);
      if (Boolean(value?.userGroupName)) {
        fetchPrivilage({
          user: { id: value.id, userGroupId: value.userGroupId },
          userGroup: null,
        });
      } else {
        fetchPrivilage({
          user: null,
          userGroup: { usergId: value.id },
        });
      }
    } else {
      // resetUserGroups();
      resetPrivilages();
    }
  };

  const handleTriggerSave = () => {
    setTriggerSave(true);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <PrivilageSettingProvider.Provider
      value={{
        privilages: privilages?.response || { permissions: [] },
        loading: privilagesLoading,
        selectedType,
        setSelectedType,
        triggerSave,
        setTriggerSave,
        resetPrivilages,
      }}
    >
      <div className="p-3">
        <Paper>
          <div className="p-3 flex items-center justify-between">
            <Typography variant="h6">User privilege</Typography>
            <Button
              onClick={handleTriggerSave}
              color="success"
              disabled={triggerSave}
              endIcon={
                triggerSave && <CircularProgress color="success" size={18} />
              }
            >
              save
            </Button>
          </div>
          <Divider />
          <div className="grid grid-cols-4 gap-2 px-3 py-4">
            {/* <FormControl>
              <RadioGroup
                onChange={handleSelectType}
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel value={0} control={<Radio />} label="User" />
                <FormControlLabel
                  value={1}
                  control={<Radio />}
                  label="User group"
                />
              </RadioGroup>
            </FormControl> */}
            <div className="col-span-2">
              <Autocomplete
                fullWidth
                value={
                  selectedType as (UsersListType & UsersTypeList) | undefined
                }
                disableClearable={true}
                options={users?.response || []}
                loading={userLoading}
                renderInput={(params) => (
                  <TextField {...params} label="Select user" />
                )}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id == value.id}
                onChange={handleDropdownChange}
              />
            </div>
            {privilagesLoading ? (
              <div className="col-span-2 flex justify-center items-center gap-2">
                <Typography>Loading</Typography>{" "}
                <CircularProgress size={18} color="primary" />
              </div>
            ) : (
              <div className="col-span-2  max-h-[80dvh] overflow-y-auto">
                <PrivilagesEdit />
              </div>
            )}
          </div>
        </Paper>
      </div>
    </PrivilageSettingProvider.Provider>
  );
};

export default UserPrivilages;
